import { render } from "./SettingsColumn.vue?vue&type=template&id=dfda8830&scoped=true"
import script from "./SettingsColumn.vue?vue&type=script&lang=js"
export * from "./SettingsColumn.vue?vue&type=script&lang=js"

import "./SettingsColumn.vue?vue&type=style&index=0&id=dfda8830&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dfda8830"

export default script